// import React, { useState, useEffect } from "react";
// import { getData, serverURL, postData } from "../../../Services/Fetchnodeservices";

// // ===================== THEME =====================
// const getT = (isDark) => ({
//   bg: isDark ? "#0c1018" : "#f0f4ff",
//   surface: isDark ? "#141824" : "#ffffff",
//   surfaceAlt: isDark ? "#1c2133" : "#f4f7ff",
//   border: isDark ? "rgba(255,255,255,0.07)" : "#e2e8f5",
//   text: isDark ? "#f1f5f9" : "#0f172a",
//   textMuted: isDark ? "#64748b" : "#94a3b8",
//   textSub: isDark ? "#94a3b8" : "#64748b",
//   shadow: isDark ? "0 4px 28px rgba(0,0,0,0.45)" : "0 4px 28px rgba(99,102,241,0.10)",
//   shadowSm: isDark ? "0 2px 10px rgba(0,0,0,0.35)" : "0 2px 10px rgba(99,102,241,0.07)",
//   accent: "#6c63ff",
//   success: "#22c55e",
//   warning: "#f59e0b",
//   danger: "#ef4444",
//   info: "#3b82f6",
// });

// // ===================== ICONS =====================
// const SearchIcon = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <circle cx="11" cy="11" r="8" />
//     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//   </svg>
// );

// const EditIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//     <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
//   </svg>
// );

// const PlusIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="12" y1="5" x2="12" y2="19" />
//     <line x1="5" y1="12" x2="19" y2="12" />
//   </svg>
// );

// const CloseIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="18" y1="6" x2="6" y2="18" />
//     <line x1="6" y1="6" x2="18" y2="18" />
//   </svg>
// );

// const DeleteIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M3 6h18" />
//     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
//   </svg>
// );

// const TruckIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <rect x="1" y="3" width="15" height="13" rx="2" />
//     <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
//     <circle cx="5.5" cy="18.5" r="2.5" />
//     <circle cx="18.5" cy="18.5" r="2.5" />
//   </svg>
// );

// const PackageIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M12 2L2 7l10 5 10-5-10-5z" />
//     <path d="M2 17l10 5 10-5" />
//     <path d="M2 12l10 5 10-5" />
//   </svg>
// );

// const ImageIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
//     <circle cx="8.5" cy="8.5" r="1.5" />
//     <polyline points="21 15 16 10 5 21" />
//   </svg>
// );

// const CalculatorIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <rect x="4" y="2" width="16" height="20" rx="2" />
//     <line x1="8" y1="6" x2="16" y2="6" />
//     <line x1="16" y1="10" x2="16" y2="10" />
//     <line x1="12" y1="10" x2="12" y2="10" />
//     <line x1="8" y1="10" x2="8" y2="10" />
//     <line x1="16" y1="14" x2="16" y2="14" />
//     <line x1="12" y1="14" x2="12" y2="14" />
//     <line x1="8" y1="14" x2="8" y2="14" />
//     <line x1="16" y1="18" x2="16" y2="18" />
//     <line x1="12" y1="18" x2="12" y2="18" />
//     <line x1="8" y1="18" x2="8" y2="18" />
//   </svg>
// );

// const AddIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <line x1="12" y1="5" x2="12" y2="19" />
//     <line x1="5" y1="12" x2="19" y2="12" />
//   </svg>
// );

// // ===================== COMPONENTS =====================
// const StatusBadge = ({ status, isDark }) => {
//   const t = getT(isDark);
//   const isActive = status === "1";
//   const config = isActive 
//     ? { bg: "rgba(34,197,94,0.15)", color: t.success, label: "Active" }
//     : { bg: "rgba(239,68,68,0.15)", color: t.danger, label: "Inactive" };
//   return (
//     <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>
//       {config.label}
//     </span>
//   );
// };

// const Toast = ({ message, type, onClose, isDark }) => {
//   const t = getT(isDark);
//   return (
//     <div style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: 1000, background: t.surface, border: `1px solid ${type === "error" ? t.danger : t.success}`, borderRadius: "12px", padding: "12px 20px", display: "flex", alignItems: "center", gap: "12px", boxShadow: t.shadow }}>
//       <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: type === "error" ? t.danger : t.success }} />
//       <span style={{ fontSize: "13px", color: type === "error" ? t.danger : t.success }}>{message}</span>
//       <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}><CloseIcon /></button>
//     </div>
//   );
// };

// // ===================== MAIN COMPONENT - DELIVERY_FARE =====================
// const DeliveryFare = ({ isDark = true }) => {
//   const t = getT(isDark);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [search, setSearch] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [editingFare, setEditingFare] = useState(null);
//   const [toast, setToast] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [activeSection, setActiveSection] = useState("dynamic");
  
//   // Data state
//   const [deliveryFares, setDeliveryFares] = useState([]);

//   // Form state for Dynamic Fare
//   const [dynamicFormData, setDynamicFormData] = useState({
//     name: "Delivery Fare",
//     pic: null,
//     map_icon: null,
//     first_trip_km: "1",
//     first_trip_fare: "0",
//     second_trip_fare: "10",
//     second_trip_km: "2",
//     third_trip_km: "4",
//     third_trip_fare: "10",
//     constant_trip_km: "6",
//     constant_trip_fare: "8",
//     on_booking_fare: "2",
//     status: "1",
//     hide: "0",
//     driver_first_trip_fare: "8",
//     driver_second_trip_fare: "8",
//     driver_third_trip_fare: "8",
//     driver_constant_trip_fare: "8",
//     driver_on_booking_fare: "0"
//   });

//   // Form state for Fixed Fare (Orders)
//   // const [fixedFormData, setFixedFormData] = useState({
//   //   name: "Fixed Delivery Fare",
//   //   pic: null,
//   //   map_icon: null,
//   //   status: "1",
//   //   hide: "0",
//   //   fixed_orders: "0",
//   //   fixed_Rupees: "0",
//   //   per_kmfare: "0"
//   // });

//   // Form state for Fixed Fare (Orders)
// const [fixedFormData, setFixedFormData] = useState({
//   name: "",
//   pic: null,
//   map_icon: null,
//   status: "1",
//   hide: "0",
//   fixed_orders: "0",
//   fixed_Rupees: "0",
//   per_kmfare: "0",
//   customer_rate_per_km: "", // Khali box rahega
//   driver_rate_per_km: ""     // Khali box rahega
// });

//   // Form state for KM Based Fare
//   const [kmRanges, setKmRanges] = useState([
//     { from_km: "", to_km: "", rupees: "" }
//   ]);
//   const [kmFareFormData, setKmFareFormData] = useState({
//     name: "KM Based Fare",
//     pic: null,
//     map_icon: null,
//     status: "1",
//     hide: "0",
//     KM_chat: ""
//   });

//   // Image previews
//   const [picPreview, setPicPreview] = useState(null);
//   const [mapIconPreview, setMapIconPreview] = useState(null);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     fetchAllFares();
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth <= 768;

//   const showToast = (message, type = "success") => {
//     setToast({ message, type });
//     setTimeout(() => setToast(null), 3500);
//   };

//   const fetchAllFares = async () => {
//     setLoading(true);
//     try {
//       const result = await getData("deliveryfare/fetch_all_fare");
//       if (result.status) {
//         setDeliveryFares(result.data);
//       } else {
//         showToast(result.message || "Failed to fetch fares", "error");
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       showToast("Network error while fetching fares", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Parse KM_chat string to array
//   const parseKmChat = (kmChat) => {
//     if (!kmChat) return [{ from_km: "", to_km: "", rupees: "" }];
//     try {
//       const parsed = JSON.parse(kmChat);
//       if (Array.isArray(parsed) && parsed.length > 0) {
//         return parsed;
//       }
//       return [{ from_km: "", to_km: "", rupees: "" }];
//     } catch (e) {
//       return [{ from_km: "", to_km: "", rupees: "" }];
//     }
//   };

//   const handleOpenModal = (fare = null) => {
//     if (fare) {
//       setEditingFare(fare);
//       const isFixedOrdersFare = fare.fixed_orders > 0 && (!fare.KM_chat || fare.KM_chat === "");
//       const isKmBasedFare = fare.KM_chat && fare.KM_chat !== "";
//       const isDynamicFare = fare.first_trip_km && fare.first_trip_km !== "0";
      
//       if (isKmBasedFare) {
//         setActiveSection("kmbased");
//         setKmRanges(parseKmChat(fare.KM_chat));
//         setKmFareFormData({
//           id: fare.id,
//           name: fare.name || "KM Based Fare",
//           pic: null,
//           map_icon: null,
//           status: fare.status || "1",
//           hide: fare.hide || "0",
//           KM_chat: fare.KM_chat || "",
//           customer_rate_per_km: fare.customer_rate_per_km || "", // Naya
//           driver_rate_per_km: fare.driver_rate_per_km || ""      // Naya
//         });
//       } else if (isFixedOrdersFare) {
//         setActiveSection("fixed");
//         setFixedFormData({
//           id: fare.id,
//           name: fare.name || "Fixed Delivery Fare",
//           pic: null,
//           map_icon: null,
//           status: fare.status || "1",
//           hide: fare.hide || "0",
//           fixed_orders: fare.fixed_orders || "0",
//           fixed_Rupees: fare.fixed_Rupees || "0",
//           per_kmfare: fare.per_kmfare || "0",
//           customer_rate_per_km: fare.customer_rate_per_km || "",
//     driver_rate_per_km: fare.driver_rate_per_km || ""
//         });
//       } else if (isDynamicFare) {
//         setActiveSection("dynamic");
//         setDynamicFormData({
//           id: fare.id,
//           name: fare.name || "Delivery Fare",
//           pic: null,
//           map_icon: null,
//           first_trip_km: fare.first_trip_km || "1",
//           first_trip_fare: fare.first_trip_fare || "0",
//           second_trip_fare: fare.second_trip_fare || "10",
//           second_trip_km: fare.second_trip_km || "2",
//           third_trip_km: fare.third_trip_km || "4",
//           third_trip_fare: fare.third_trip_fare || "10",
//           constant_trip_km: fare.constant_trip_km || "6",
//           constant_trip_fare: fare.constant_trip_fare || "8",
//           on_booking_fare: fare.on_booking_fare || "2",
//           status: fare.status || "1",
//           hide: fare.hide || "0",
//           driver_first_trip_fare: fare.driver_first_trip_fare || "8",
//           driver_second_trip_fare: fare.driver_second_trip_fare || "8",
//           driver_third_trip_fare: fare.driver_third_trip_fare || "8",
//           driver_constant_trip_fare: fare.driver_constant_trip_fare || "8",
//           driver_on_booking_fare: fare.driver_on_booking_fare || "0"
//         });
//       }
//       setPicPreview(fare.pic ? `${serverURL}/uploads/${fare.pic}` : null);
//       setMapIconPreview(fare.map_icon ? `${serverURL}/uploads/${fare.map_icon}` : null);
//     } else {
//       setEditingFare(null);
//       setActiveSection("dynamic");
//       setDynamicFormData({
//         name: "Delivery Fare",
//         pic: null,
//         map_icon: null,
//         first_trip_km: "1",
//         first_trip_fare: "0",
//         second_trip_fare: "10",
//         second_trip_km: "2",
//         third_trip_km: "4",
//         third_trip_fare: "10",
//         constant_trip_km: "6",
//         constant_trip_fare: "8",
//         on_booking_fare: "2",
//         status: "1",
//         hide: "0",
//         driver_first_trip_fare: "8",
//         driver_second_trip_fare: "8",
//         driver_third_trip_fare: "8",
//         driver_constant_trip_fare: "8",
//         driver_on_booking_fare: "0"
//       });
//       setFixedFormData({
//         name: "Fixed Delivery Fare",
//         pic: null,
//         map_icon: null,
//         status: "1",
//         hide: "0",
//         fixed_orders: "0",
//         fixed_Rupees: "0",
//         per_kmfare: "0"
//       });
//       setKmRanges([{ from_km: "", to_km: "", rupees: "" }]);
//       setKmFareFormData({
//         name: "KM Based Fare",
//         pic: null,
//         map_icon: null,
//         status: "1",
//         hide: "0",
//         KM_chat: ""
//       });
//       setPicPreview(null);
//       setMapIconPreview(null);
//     }
//     setShowModal(true);
//   };

//   const handleAddKmRange = () => {
//     setKmRanges([...kmRanges, { from_km: "", to_km: "", rupees: "" }]);
//   };

//   const handleRemoveKmRange = (index) => {
//     const newRanges = kmRanges.filter((_, i) => i !== index);
//     setKmRanges(newRanges.length > 0 ? newRanges : [{ from_km: "", to_km: "", rupees: "" }]);
//   };

//   const handleKmRangeChange = (index, field, value) => {
//     const newRanges = [...kmRanges];
//     newRanges[index][field] = value;
//     setKmRanges(newRanges);
//   };

//   const handleFileChange = (e, type) => {
//     const file = e.target.files[0];
//     if (file) {
//       const previewUrl = URL.createObjectURL(file);
//       if (type === "pic") {
//         setPicPreview(previewUrl);
//         if (activeSection === "dynamic") {
//           setDynamicFormData({ ...dynamicFormData, pic: file });
//         } else if (activeSection === "fixed") {
//           setFixedFormData({ ...fixedFormData, pic: file });
//         } else if (activeSection === "kmbased") {
//           setKmFareFormData({ ...kmFareFormData, pic: file });
//         }
//       }
//       if (type === "map_icon") {
//         setMapIconPreview(previewUrl);
//         if (activeSection === "dynamic") {
//           setDynamicFormData({ ...dynamicFormData, map_icon: file });
//         } else if (activeSection === "fixed") {
//           setFixedFormData({ ...fixedFormData, map_icon: file });
//         } else if (activeSection === "kmbased") {
//           setKmFareFormData({ ...kmFareFormData, map_icon: file });
//         }
//       }
//     }
//   };

//   const handleSaveFare = async () => {
//     setSubmitting(true);
    
//     try {
//       let result;
      
//       // Fixed Orders Section
//       if (activeSection === "fixed") {
//         if (!fixedFormData.name) {
//           showToast("Name is required", "error");
//           setSubmitting(false);
//           return;
//         }

//         const submitFormData = new FormData();
//         submitFormData.append("name", fixedFormData.name);
//         submitFormData.append("status", fixedFormData.status);
//         submitFormData.append("hide", fixedFormData.hide || "0");
//         submitFormData.append("fixed_orders", fixedFormData.fixed_orders);
//         submitFormData.append("fixed_Rupees", fixedFormData.fixed_Rupees);
//         submitFormData.append("per_kmfare", fixedFormData.per_kmfare);
//             Object.keys(fixedFormData).forEach(key => submitFormData.append(key, fixedFormData[key]));


//         submitFormData.append("customer_rate_per_km", fixedFormData.customer_rate_per_km);
// submitFormData.append("driver_rate_per_km", fixedFormData.driver_rate_per_km);
        
//         if (fixedFormData.pic instanceof File) {
//           submitFormData.append("pic", fixedFormData.pic);
//         }
//         if (fixedFormData.map_icon instanceof File) {
//           submitFormData.append("map_icon", fixedFormData.map_icon);
//         }
        
//         if (editingFare) {
//           submitFormData.append("id", editingFare.id);
//           result = await postData("deliveryfare/update_fixedfare", submitFormData);
//         } else {
//           result = await postData("deliveryfare/add_fixedfare", submitFormData);
//         }
        
//         if (result.status) {
//           showToast(editingFare ? "Fixed fare updated successfully" : "Fixed fare added successfully");
//           fetchAllFares();
//           setShowModal(false);
//         } else {
//           showToast(result.message || "Operation failed", "error");
//         }
//       } 
//       // KM Based Fare Section
//       else if (activeSection === "kmbased") {
//         if (!kmFareFormData.name) {
//           showToast("Name is required", "error");
//           setSubmitting(false);
//           return;
//         }

//         const validRanges = kmRanges.filter(range => range.from_km && range.to_km && range.rupees);
//         if (validRanges.length === 0) {
//           showToast("Please add at least one valid KM range", "error");
//           setSubmitting(false);
//           return;
//         }

//         const KM_chat = JSON.stringify(validRanges);
        
//         const submitFormData = new FormData();
//         submitFormData.append("name", kmFareFormData.name);
//         submitFormData.append("status", kmFareFormData.status);
//         submitFormData.append("hide", kmFareFormData.hide || "0");
//         submitFormData.append("KM_chat", KM_chat);
        
//         if (kmFareFormData.pic instanceof File) {
//           submitFormData.append("pic", kmFareFormData.pic);
//         }
//         if (kmFareFormData.map_icon instanceof File) {
//           submitFormData.append("map_icon", kmFareFormData.map_icon);
//         }
        
//         if (editingFare) {
//           submitFormData.append("id", editingFare.id);
//           result = await postData("deliveryfare/update_fixedkmfare", submitFormData);
//         } else {
//           result = await postData("deliveryfare/add_fixedkmfare", submitFormData);
//         }
        
//         if (result.status) {
//           showToast(editingFare ? "KM based fare updated successfully" : "KM based fare added successfully");
//           fetchAllFares();
//           setShowModal(false);
//         } else {
//           showToast(result.message || "Operation failed", "error");
//         }
//       }
//       // Dynamic Fare Section
//       else {
//         if (!dynamicFormData.name) {
//           showToast("Name is required", "error");
//           setSubmitting(false);
//           return;
//         }

//         const submitFormData = new FormData();
//         Object.keys(dynamicFormData).forEach(key => {
//           if (key === "pic" || key === "map_icon") {
//             if (dynamicFormData[key] instanceof File) {
//               submitFormData.append(key, dynamicFormData[key]);
//             }
//           } else if (key !== "id" && dynamicFormData[key] !== null && dynamicFormData[key] !== undefined) {
//             submitFormData.append(key, dynamicFormData[key]);
//           }
//         });
        
//         if (editingFare) {
//           submitFormData.append("id", editingFare.id);
//           result = await postData("deliveryfare/update_fare", submitFormData);
//         } else {
//           result = await postData("deliveryfare/add_fare", submitFormData);
//         }
        
//         if (result.status) {
//           showToast(editingFare ? "Dynamic fare updated successfully" : "Dynamic fare added successfully");
//           fetchAllFares();
//           setShowModal(false);
//         } else {
//           showToast(result.message || "Operation failed", "error");
//         }
//       }
//     } catch (error) {
//       console.error("Save error:", error);
//       showToast("Network error while saving", "error");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleToggleStatus = async (fare) => {
//     const newStatus = fare.status === "1" ? "0" : "1";
    
//     setSubmitting(true);
//     try {
//       const result = await postData("deliveryfare/update_status", { 
//         id: fare.id, 
//         status: newStatus 
//       });
//       if (result.status) {
//         showToast(`Fare ${newStatus === "1" ? "activated" : "deactivated"} successfully`);
//         fetchAllFares();
//       } else {
//         showToast(result.message || "Status update failed", "error");
//       }
//     } catch (error) {
//       console.error("Status update error:", error);
//       showToast("Network error while updating status", "error");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const filteredFares = deliveryFares.filter(fare => 
//     fare.name?.toLowerCase().includes(search.toLowerCase()) ||
//     fare.status?.toString().includes(search)
//   );

//   const styles = {
//     container: {
//       minHeight: "100vh",
//       background: t.bg,
//       fontFamily: "'Inter', 'DM Sans', sans-serif",
//       padding: isMobile ? "16px" : "24px",
//     },
//     contentWrapper: {
//       maxWidth: "1600px",
//       margin: "0 auto",
//     },
//     header: {
//       marginBottom: "28px",
//     },
//     title: {
//       fontSize: isMobile ? "24px" : "32px",
//       fontWeight: 700,
//       background: "linear-gradient(135deg, #6c63ff, #a855f7)",
//       WebkitBackgroundClip: "text",
//       WebkitTextFillColor: "transparent",
//       margin: 0,
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: t.textMuted,
//       marginTop: "8px",
//     },
//     card: {
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "24px",
//       overflow: "hidden",
//       boxShadow: t.shadow,
//     },
//     cardHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       padding: "20px 24px",
//       borderBottom: `1px solid ${t.border}`,
//       background: t.surfaceAlt,
//       flexWrap: "wrap",
//       gap: "12px",
//     },
//     cardTitle: {
//       fontSize: "18px",
//       fontWeight: 700,
//       color: t.text,
//       margin: 0,
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     searchWrapper: {
//       position: "relative",
//       width: isMobile ? "100%" : "280px",
//     },
//     searchInput: {
//       width: "100%",
//       padding: "10px 12px 10px 36px",
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "13px",
//       color: t.text,
//       outline: "none",
//     },
//     addButton: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       padding: "10px 20px",
//       background: "linear-gradient(135deg, #6c63ff, #a855f7)",
//       border: "none",
//       borderRadius: "12px",
//       color: "#fff",
//       fontSize: "13px",
//       fontWeight: 600,
//       cursor: "pointer",
//     },
//     headerActions: {
//       display: "flex",
//       gap: "20px",
//       alignItems: "center",
//       flexWrap: "wrap",
//     },
//     tableWrapper: {
//       overflowX: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "1300px",
//     },
//     th: {
//       padding: "16px 12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: 700,
//       color: t.accent,
//       borderBottom: `1px solid ${t.border}`,
//       background: t.surfaceAlt,
//     },
//     td: {
//       padding: "16px 12px",
//       fontSize: "13px",
//       color: t.textSub,
//       borderBottom: `1px solid ${t.border}`,
//     },
//     actionButtons: {
//       display: "flex",
//       gap: "8px",
//       alignItems: "center",
//       flexWrap: "wrap",
//     },
//     editBtn: {
//       display: "flex",
//       alignItems: "center",
//       gap: "4px",
//       padding: "6px 12px",
//       borderRadius: "8px",
//       border: "none",
//       fontSize: "11px",
//       fontWeight: 500,
//       cursor: "pointer",
//       background: t.info,
//       color: "#fff",
//     },
//     toggleBtn: (isActive) => ({
//       padding: "6px 12px",
//       borderRadius: "20px",
//       border: "none",
//       fontSize: "11px",
//       fontWeight: 500,
//       cursor: "pointer",
//       background: isActive ? t.success : t.warning,
//       color: "#fff",
//     }),
//     modalOverlay: {
//       position: "fixed",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       zIndex: 1000,
//       background: "rgba(0,0,0,0.7)",
//       backdropFilter: "blur(8px)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "20px",
//     },
//     modal: {
//       background: t.surface,
//       border: `1px solid ${t.border}`,
//       borderRadius: "28px",
//       width: isMobile ? "100%" : "950px",
//       maxHeight: "85vh",
//       display: "flex",
//       flexDirection: "column",
//       boxShadow: t.shadow,
//     },
//     modalHeader: {
//       padding: "20px 24px",
//       borderBottom: `1px solid ${t.border}`,
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       flexShrink: 0,
//       background: t.surface,
//       borderRadius: "28px 28px 0 0",
//     },
//     modalTitle: {
//       fontSize: "20px",
//       fontWeight: 700,
//       color: t.text,
//     },
//     modalBody: {
//       padding: "24px",
//       overflowY: "auto",
//       flex: 1,
//     },
//     modalFooter: {
//       padding: "16px 24px",
//       borderTop: `1px solid ${t.border}`,
//       display: "flex",
//       gap: "12px",
//       justifyContent: "flex-end",
//       flexShrink: 0,
//       background: t.surface,
//       borderRadius: "0 0 28px 28px",
//     },
//     formGroup: {
//       marginBottom: "20px",
//     },
//     label: {
//       display: "block",
//       fontSize: "12px",
//       fontWeight: 600,
//       color: t.textMuted,
//       marginBottom: "6px",
//       textTransform: "uppercase",
//       letterSpacing: "0.5px",
//     },
//     input: {
//       width: "100%",
//       padding: "12px 14px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "14px",
//       color: t.text,
//       outline: "none",
//       fontFamily: "inherit",
//     },
//     select: {
//       width: "100%",
//       padding: "12px 14px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "14px",
//       color: t.text,
//       outline: "none",
//       cursor: "pointer",
//     },
//     fileInput: {
//       width: "100%",
//       padding: "10px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       fontSize: "13px",
//       color: t.text,
//       cursor: "pointer",
//     },
//     imagePreview: {
//       width: "80px",
//       height: "80px",
//       objectFit: "cover",
//       borderRadius: "12px",
//       marginTop: "12px",
//       border: `2px solid ${t.border}`,
//     },
//     cancelBtn: {
//       padding: "10px 24px",
//       background: t.surfaceAlt,
//       border: `1px solid ${t.border}`,
//       borderRadius: "12px",
//       color: t.text,
//       cursor: "pointer",
//       fontSize: "13px",
//       fontWeight: 500,
//     },
//     saveBtn: {
//       padding: "10px 24px",
//       background: "linear-gradient(135deg, #6c63ff, #a855f7)",
//       border: "none",
//       borderRadius: "12px",
//       color: "#fff",
//       cursor: "pointer",
//       fontWeight: 600,
//       fontSize: "13px",
//     },
//     rowCount: {
//       padding: "16px 24px",
//       borderTop: `1px solid ${t.border}`,
//       fontSize: "12px",
//       color: t.textMuted,
//       background: t.surfaceAlt,
//     },
//     loadingText: {
//       textAlign: "center",
//       padding: "60px",
//       color: t.textMuted,
//       fontSize: "14px",
//     },
//     sectionToggle: {
//       display: "flex",
//       gap: "12px",
//       marginBottom: "24px",
//       background: t.surfaceAlt,
//       padding: "6px",
//       borderRadius: "16px",
//       flexWrap: "wrap",
//     },
//     toggleButton: (isActive) => ({
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       padding: "10px 20px",
//       background: isActive ? "linear-gradient(135deg, #6c63ff, #a855f7)" : "transparent",
//       border: "none",
//       borderRadius: "12px",
//       fontSize: "13px",
//       fontWeight: 600,
//       color: isActive ? "#fff" : t.text,
//       cursor: "pointer",
//       transition: "all 0.2s",
//       flex: 1,
//       justifyContent: "center",
//     }),
//     dynamicSection: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "20px",
//     },
//     fixedSection: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "20px",
//     },
//     kmBasedSection: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "20px",
//     },
//     sectionCard: {
//       background: t.surfaceAlt,
//       borderRadius: "16px",
//       padding: "20px",
//     },
//     sectionTitle: {
//       fontSize: "14px",
//       fontWeight: 600,
//       color: t.accent,
//       marginBottom: "16px",
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     grid3: {
//       display: "grid",
//       gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
//       gap: "16px",
//     },
//     grid2: {
//       display: "grid",
//       gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
//       gap: "16px",
//     },
//     rangeRow: {
//       display: "grid",
//       gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr auto",
//       gap: "12px",
//       alignItems: "center",
//       marginBottom: "12px",
//     },
//     addButtonSmall: {
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       padding: "8px 16px",
//       background: "transparent",
//       border: `2px dashed ${t.border}`,
//       borderRadius: "12px",
//       color: t.accent,
//       fontSize: "12px",
//       fontWeight: 500,
//       cursor: "pointer",
//       marginTop: "12px",
//       width: "100%",
//       justifyContent: "center",
//     },
//     deleteBtnSmall: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "8px",
//       background: t.danger,
//       border: "none",
//       borderRadius: "8px",
//       cursor: "pointer",
//       color: "#fff",
//     },
//   };

//   // Render mobile card view
//   const renderMobileCard = (fare, index) => {
//     let kmRangesDisplay = "-";
//     if (fare.KM_chat) {
//       try {
//         const ranges = JSON.parse(fare.KM_chat);
//         if (ranges.length > 0) {
//           kmRangesDisplay = ranges.map(r => `${r.from_km}-${r.to_km}km: ₹${r.rupees}`).join(", ");
//         }
//       } catch(e) {}
//     }
    
//     return (
//       <div key={fare.id} style={{ 
//         background: t.surfaceAlt, 
//         borderRadius: "16px", 
//         marginBottom: "12px",
//         padding: "16px",
//         border: `1px solid ${t.border}`
//       }}>
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
//           <strong style={{ color: t.text }}>#{index + 1} - {fare.name}</strong>
//           <StatusBadge status={fare.status} isDark={isDark} />
//         </div>
//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "12px" }}>
//           <div><span style={{ color: t.textMuted }}>ID:</span> {fare.id}</div>
//           <div><span style={{ color: t.textMuted }}>Type:</span> {fare.first_trip_km ? "Dynamic" : fare.fixed_orders ? "Fixed Orders" : "KM Based"}</div>
//           <div><span style={{ color: t.textMuted }}>Fixed Orders:</span> {fare.fixed_orders || "-"}</div>
//           <div><span style={{ color: t.textMuted }}>Fixed Price:</span> {fare.fixed_Rupees ? `₹${fare.fixed_Rupees}` : "-"}</div>
//           <div><span style={{ color: t.textMuted }}>Per KM Fare:</span> {fare.per_kmfare ? `₹${fare.per_kmfare}` : "-"}</div>
//           <div style={{ gridColumn: "span 2" }}><span style={{ color: t.textMuted }}>KM Ranges:</span> {kmRangesDisplay}</div>
//         </div>
//         <div style={styles.actionButtons}>
//           <button style={styles.editBtn} onClick={() => handleOpenModal(fare)}>
//             <EditIcon /> Edit
//           </button>
//           <button 
//             style={styles.toggleBtn(fare.status === "1")} 
//             onClick={() => handleToggleStatus(fare)}
//             disabled={submitting}
//           >
//             {fare.status === "1" ? "Deactivate" : "Activate"}
//           </button>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.contentWrapper}>
//         <div style={styles.header}>
//           <h1 style={styles.title}>💰 Delivery Fare Management</h1>
//           <p style={styles.subtitle}>Configure delivery charges, booking fees, and fare rules</p>
//         </div>

//         <div style={styles.card}>
//           <div style={styles.cardHeader}>
//             <h3 style={styles.cardTitle}>
//               <TruckIcon /> Delivery Fare Configuration
//             </h3>
//             <div style={styles.headerActions}>
//               <div style={styles.searchWrapper}>
//                 <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }}><SearchIcon /></span>
//                 <input 
//                   style={styles.searchInput} 
//                   placeholder="Search by name or status..." 
//                   value={search} 
//                   onChange={(e) => setSearch(e.target.value)} 
//                 />
//               </div>
//               <button style={styles.addButton} onClick={() => handleOpenModal()}>
//                 <PlusIcon /> Add Fare
//               </button>
//             </div>
//           </div>

//           <div style={styles.tableWrapper}>
//             {loading ? (
//               <div style={styles.loadingText}>Loading fares...</div>
//             ) : (
//               isMobile ? (
//                 filteredFares.map((fare, index) => renderMobileCard(fare, index))
//               ) : (
//                 <table style={styles.table}>
//                   <thead>
//                     <tr>
//                       <th style={styles.th}>SN</th>
//                       <th style={styles.th}>ID</th>
//                       <th style={styles.th}>Name</th>
//                       <th style={styles.th}>Cust. Rate/KM</th> {/* Naya */}
// <th style={styles.th}>Driver Rate/KM</th> {/* Naya */}
//                       <th style={styles.th}>1st KM/Fare</th>
//                       <th style={styles.th}>2nd KM/Fare</th>
//                       <th style={styles.th}>3rd KM/Fare</th>
//                       <th style={styles.th}>Constant KM/Fare</th>
//                       <th style={styles.th}>Booking Fee</th>
//                       <th style={styles.th}>Fixed Orders</th>
//                       <th style={styles.th}>Fixed Price</th>
//                       <th style={styles.th}>Per KM Fare</th>
//                       <th style={styles.th}>KM Ranges</th>
//                       <th style={styles.th}>Driver Fares</th>
//                       <th style={styles.th}>Status</th>
//                       <th style={styles.th}>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredFares.map((fare, index) => {
//                       let kmRangesDisplay = "-";
//                       if (fare.KM_chat) {
//                         try {
//                           const ranges = JSON.parse(fare.KM_chat);
//                           if (ranges.length > 0) {
//                             kmRangesDisplay = ranges.map(r => `${r.from_km}-${r.to_km}km:₹${r.rupees}`).join(", ");
//                           }
//                         } catch(e) {}
//                       }
                      
//                       return (
//                         <tr key={fare.id}>
//                           <td style={styles.td}>{index + 1}</td>
//                           <td style={styles.td}>{fare.id}</td>
//                           <td style={styles.td}><strong style={{ color: t.text }}>{fare.name}</strong></td>
// <td style={styles.td}><span style={{color: t.success, fontWeight:'bold'}}>₹{fare.customer_rate_per_km || "0"}</span></td> {/* Naya */}
// <td style={styles.td}><span style={{color: t.accent, fontWeight:'bold'}}>₹{fare.driver_rate_per_km || "0"}</span></td>

//                           <td style={styles.td}>{fare.first_trip_km && fare.first_trip_km !== "0" ? `${fare.first_trip_km} km / $${fare.first_trip_fare}` : "-"}</td>
//                           <td style={styles.td}>{fare.second_trip_km && fare.second_trip_km !== "0" ? `${fare.second_trip_km} km / $${fare.second_trip_fare}` : "-"}</td>
//                           <td style={styles.td}>{fare.third_trip_km && fare.third_trip_km !== "0" ? `${fare.third_trip_km} km / $${fare.third_trip_fare}` : "-"}</td>
//                           <td style={styles.td}>{fare.constant_trip_km && fare.constant_trip_km !== "0" ? `${fare.constant_trip_km} km / $${fare.constant_trip_fare}` : "-"}</td>
//                           <td style={styles.td}>{fare.on_booking_fare && fare.on_booking_fare !== "0" ? `$${fare.on_booking_fare}` : "-"}</td>
//                           <td style={styles.td}>{fare.fixed_orders && fare.fixed_orders !== "0" ? `${fare.fixed_orders} orders` : "-"}</td>
//                           <td style={styles.td}>{fare.fixed_Rupees && fare.fixed_Rupees !== "0" ? `₹${fare.fixed_Rupees}` : "-"}</td>
//                           <td style={styles.td}>{fare.per_kmfare && fare.per_kmfare !== "0" ? `₹${fare.per_kmfare}` : "-"}</td>
//                           <td style={styles.td}>{kmRangesDisplay}</td>
//                           <td style={styles.td}>
//                             {fare.driver_first_trip_fare && fare.driver_first_trip_fare !== "0" ? (
//                               <div style={{ fontSize: "10px" }}>
//                                 First: ${fare.driver_first_trip_fare}<br />
//                                 Second: ${fare.driver_second_trip_fare}<br />
//                                 Constant: ${fare.driver_constant_trip_fare}
//                               </div>
//                             ) : "-"}
//                           </td>
//                           <td style={styles.td}><StatusBadge status={fare.status} isDark={isDark} /></td>
//                           <td style={styles.td}>
//                             <div style={styles.actionButtons}>
//                               <button style={styles.editBtn} onClick={() => handleOpenModal(fare)}>
//                                 <EditIcon /> Edit
//                               </button>
//                               <button 
//                                 style={styles.toggleBtn(fare.status === "1")} 
//                                 onClick={() => handleToggleStatus(fare)}
//                                 disabled={submitting}
//                               >
//                                 {fare.status === "1" ? "Deactivate" : "Activate"}
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               )
//             )}
//           </div>

//           <div style={styles.rowCount}>
//             Rows: 20 ▼ | {filteredFares.length} of {deliveryFares.length} — Page 1/1
//           </div>
//         </div>
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
//           <div style={styles.modal} onClick={e => e.stopPropagation()}>
//             <div style={styles.modalHeader}>
//               <div style={styles.modalTitle}>{editingFare ? "Edit Delivery Fare" : "Create New Fare"}</div>
//               <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted, padding: "8px", borderRadius: "8px" }}>
//                 <CloseIcon />
//               </button>
//             </div>
//             <div style={styles.modalBody}>
//               {/* Section Toggle Buttons */}
//               <div style={styles.sectionToggle}>
//                 <button 
//                   style={styles.toggleButton(activeSection === "dynamic")}
//                   onClick={() => setActiveSection("dynamic")}
//                 >
//                   <TruckIcon /> Dynamic Fare (KM Based)
//                 </button>
//                 <button 
//                   style={styles.toggleButton(activeSection === "fixed")}
//                   onClick={() => setActiveSection("fixed")}
//                 >
//                   <PackageIcon /> Fixed Orders
//                 </button>
//                 <button 
//                   style={styles.toggleButton(activeSection === "kmbased")}
//                   onClick={() => setActiveSection("kmbased")}
//                 >
//                   <CalculatorIcon /> KM Based Fare
//                 </button>
//               </div>

//               {/* Dynamic Fare Section */}
//               {activeSection === "dynamic" && (
//                 <div style={styles.dynamicSection}>
//                   <div style={styles.grid2}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Fare Name *</label>
//                       <input style={styles.input} value={dynamicFormData.name} onChange={(e) => setDynamicFormData({ ...dynamicFormData, name: e.target.value })} placeholder="e.g., Standard Delivery" />
//                     </div>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Status</label>
//                       <select style={styles.select} value={dynamicFormData.status} onChange={(e) => setDynamicFormData({ ...dynamicFormData, status: e.target.value })}>
//                         <option value="1">Active</option>
//                         <option value="0">Inactive</option>
//                       </select>
//                     </div>
//                   </div>
// <div style={styles.sectionCard}>
//   <div style={styles.sectionTitle}>
//     <CalculatorIcon /> Pricing per Kilometer
//   </div>
//   <div style={styles.grid2}>
//     <div style={styles.formGroup}>
//       <label style={styles.label}>Customer Rate (₹ per KM) *</label>
//       <input 
//         type="number" 
//         style={styles.input} 
//         value={fixedFormData.customer_rate_per_km} 
//         onChange={(e) => setFixedFormData({ ...fixedFormData, customer_rate_per_km: e.target.value })}
//         placeholder="e.g. 15"
//       />
//     </div>
//     <div style={styles.formGroup}>
//       <label style={styles.label}>Driver Rate (₹ per KM) *</label>
//       <input 
//         type="number" 
//         style={styles.input} 
//         value={fixedFormData.driver_rate_per_km} 
//         onChange={(e) => setFixedFormData({ ...fixedFormData, driver_rate_per_km: e.target.value })}
//         placeholder="e.g. 10"
//       />
//     </div>
//   </div>
  
//   <div style={{...styles.grid2, marginTop: '20px'}}>
//     <div style={styles.formGroup}>
//       <label style={styles.label}>Fixed Price (₹)</label>
//       <input type="number" style={styles.input} value={fixedFormData.fixed_Rupees} onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_Rupees: e.target.value })} />
//     </div>
//     <div style={styles.formGroup}>
//       <label style={styles.label}>Fixed Orders (Qty)</label>
//       <input type="number" style={styles.input} value={fixedFormData.fixed_orders} onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_orders: e.target.value })} />
//     </div>
//   </div>
// </div>
//                   <div style={styles.sectionCard}>
//                     <div style={styles.sectionTitle}>
//                       <TruckIcon /> Customer Fares
//                     </div>
//                     <div style={styles.grid3}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>1st Trip KM</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.first_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, first_trip_km: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>1st Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.first_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, first_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>2nd Trip KM</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.second_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, second_trip_km: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>2nd Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.second_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, second_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>3rd Trip KM</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.third_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, third_trip_km: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>3rd Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.third_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, third_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Constant Trip KM</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.constant_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, constant_trip_km: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Constant Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.constant_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, constant_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>On Booking Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.on_booking_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, on_booking_fare: e.target.value })} />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Modal ke andar 'Fixed Orders Configuration' wale section mein ye add kar */}
// <div style={styles.grid2}>
//   <div style={styles.formGroup}>
//     <label style={styles.label}>Customer Rate (₹ per KM) *</label>
//     <input 
//       type="number" 
//       style={styles.input} 
//       value={fixedFormData.customer_rate_per_km} 
//       onChange={(e) => setFixedFormData({ ...fixedFormData, customer_rate_per_km: e.target.value })}
//       placeholder="Apna rate bhariyo (e.g. 12)"
//     />
//   </div>
//   <div style={styles.formGroup}>
//     <label style={styles.label}>Driver Rate (₹ per KM) *</label>
//     <input 
//       type="number" 
//       style={styles.input} 
//       value={fixedFormData.driver_rate_per_km} 
//       onChange={(e) => setFixedFormData({ ...fixedFormData, driver_rate_per_km: e.target.value })}
//       placeholder="Driver ka rate (e.g. 9)"
//     />
//   </div>
// </div>

//                   <div style={styles.sectionCard}>
//                     <div style={styles.sectionTitle}>
//                       👨‍✈️ Driver Fares
//                     </div>
//                     <div style={styles.grid3}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Driver 1st Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.driver_first_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_first_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Driver 2nd Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.driver_second_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_second_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Driver 3rd Trip Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.driver_third_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_third_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Driver Constant Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.driver_constant_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_constant_trip_fare: e.target.value })} />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Driver On Booking Fare ($)</label>
//                         <input type="number" style={styles.input} value={dynamicFormData.driver_on_booking_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_on_booking_fare: e.target.value })} />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Fixed Orders Section */}
//               {activeSection === "fixed" && (
//                 <div style={styles.fixedSection}>
//                   <div style={styles.grid2}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Fare Name *</label>
//                       <input style={styles.input} value={fixedFormData.name} onChange={(e) => setFixedFormData({ ...fixedFormData, name: e.target.value })} placeholder="e.g., Bulk Order Pricing" />
//                     </div>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Status</label>
//                       <select style={styles.select} value={fixedFormData.status} onChange={(e) => setFixedFormData({ ...fixedFormData, status: e.target.value })}>
//                         <option value="1">Active</option>
//                         <option value="0">Inactive</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.sectionCard}>
//                     <div style={styles.sectionTitle}>
//                       <PackageIcon /> Fixed Orders Configuration
//                     </div>
//                     <div style={styles.grid2}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Fixed Orders (Quantity)</label>
//                         <input 
//                           type="number" 
//                           style={styles.input} 
//                           value={fixedFormData.fixed_orders} 
//                           onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_orders: e.target.value })}
//                           placeholder="Number of orders"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Fixed Price (₹)</label>
//                         <input 
//                           type="number" 
//                           style={styles.input} 
//                           value={fixedFormData.fixed_Rupees} 
//                           onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_Rupees: e.target.value })}
//                           placeholder="Total price in Rupees"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Per KM Fare (₹)</label>
//                         <input 
//                           type="number" 
//                           style={styles.input} 
//                           value={fixedFormData.per_kmfare} 
//                           onChange={(e) => setFixedFormData({ ...fixedFormData, per_kmfare: e.target.value })}
//                           placeholder="Price per kilometer"
//                         />
//                         <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "6px", display: "block" }}>
//                           Additional charge per kilometer
//                         </small>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* KM Based Fare Section */}
//               {activeSection === "kmbased" && (
//                 <div style={styles.kmBasedSection}>
//  <div style={styles.sectionCard}>
//                     <div style={styles.sectionTitle}><CalculatorIcon /> Global Rates (Standard)</div>
//                     <div style={styles.grid2}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Customer Rate (₹ per KM) *</label>
//                         <input 
//                           type="number" 
//                           style={styles.input} 
//                           value={kmFareFormData.customer_rate_per_km} 
//                           onChange={(e) => setKmFareFormData({ ...kmFareFormData, customer_rate_per_km: e.target.value })}
//                           placeholder="e.g. 15"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Driver Rate (₹ per KM) *</label>
//                         <input 
//                           type="number" 
//                           style={styles.input} 
//                           value={kmFareFormData.driver_rate_per_km} 
//                           onChange={(e) => setKmFareFormData({ ...kmFareFormData, driver_rate_per_km: e.target.value })}
//                           placeholder="e.g. 10"
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div style={styles.grid2}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Fare Name *</label>
//                       <input style={styles.input} value={kmFareFormData.name} onChange={(e) => setKmFareFormData({ ...kmFareFormData, name: e.target.value })} placeholder="e.g., Distance Based Pricing" />
//                     </div>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Status</label>
//                       <select style={styles.select} value={kmFareFormData.status} onChange={(e) => setKmFareFormData({ ...kmFareFormData, status: e.target.value })}>
//                         <option value="1">Active</option>
//                         <option value="0">Inactive</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div style={styles.sectionCard}>
//                     <div style={styles.sectionTitle}>
//                       <CalculatorIcon /> KM Ranges Configuration
//                     </div>
                    
//                     {kmRanges.map((range, idx) => (
//                       <div key={idx} style={styles.rangeRow}>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>From KM</label>
//                           <input 
//                             type="number" 
//                             style={styles.input} 
//                             value={range.from_km} 
//                             onChange={(e) => handleKmRangeChange(idx, "from_km", e.target.value)}
//                             placeholder="From"
//                           />
//                         </div>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>To KM</label>
//                           <input 
//                             type="number" 
//                             style={styles.input} 
//                             value={range.to_km} 
//                             onChange={(e) => handleKmRangeChange(idx, "to_km", e.target.value)}
//                             placeholder="To"
//                           />
//                         </div>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Rupees (₹)</label>
//                           <input 
//                             type="number" 
//                             style={styles.input} 
//                             value={range.rupees} 
//                             onChange={(e) => handleKmRangeChange(idx, "rupees", e.target.value)}
//                             placeholder="Price"
//                           />
//                         </div>
//                         <div>
//                           <label style={{ visibility: "hidden" }}>Action</label>
//                           <button 
//                             style={styles.deleteBtnSmall} 
//                             onClick={() => handleRemoveKmRange(idx)}
//                           >
//                             <DeleteIcon />
//                           </button>
//                         </div>
//                       </div>
//                     ))}
                    
//                     <button style={styles.addButtonSmall} onClick={handleAddKmRange}>
//                       <AddIcon /> Add KM Range
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* Images Section */}
//               <div style={styles.sectionCard}>
//                 <div style={styles.sectionTitle}>
//                   <ImageIcon /> Brand Images
//                 </div>
//                 <div style={styles.grid2}>
//                   <div style={styles.formGroup}>
//                     <label style={styles.label}>Picture / Logo</label>
//                     <input type="file" style={styles.fileInput} accept="image/*" onChange={(e) => handleFileChange(e, "pic")} />
//                     {picPreview && <img src={picPreview} alt="Preview" style={styles.imagePreview} />}
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.label}>Map Icon</label>
//                     <input type="file" style={styles.fileInput} accept="image/*" onChange={(e) => handleFileChange(e, "map_icon")} />
//                     {mapIconPreview && <img src={mapIconPreview} alt="Map Icon Preview" style={styles.imagePreview} />}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div style={styles.modalFooter}>
//               <button style={styles.cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
//               <button style={styles.saveBtn} onClick={handleSaveFare} disabled={submitting}>
//                 {submitting ? "Saving..." : (editingFare ? "Update Fare" : "Create Fare")}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} isDark={isDark} />}
//     </div>
//   );
// };

// export default DeliveryFare;

import React, { useState, useEffect } from "react";
import { getData, serverURL, postData } from "../../../Services/Fetchnodeservices";

// ===================== THEME =====================
const getT = (isDark) => ({
  bg: isDark ? "#0c1018" : "#f0f4ff",
  surface: isDark ? "#141824" : "#ffffff",
  surfaceAlt: isDark ? "#1c2133" : "#f4f7ff",
  border: isDark ? "rgba(255,255,255,0.07)" : "#e2e8f5",
  text: isDark ? "#f1f5f9" : "#0f172a",
  textMuted: isDark ? "#64748b" : "#94a3b8",
  textSub: isDark ? "#94a3b8" : "#64748b",
  shadow: isDark ? "0 4px 28px rgba(0,0,0,0.45)" : "0 4px 28px rgba(99,102,241,0.10)",
  shadowSm: isDark ? "0 2px 10px rgba(0,0,0,0.35)" : "0 2px 10px rgba(99,102,241,0.07)",
  accent: "#6c63ff",
  success: "#22c55e",
  warning: "#f59e0b",
  danger: "#ef4444",
  info: "#3b82f6",
});

// ===================== ICONS =====================
const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 6h18" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

const TruckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="1" y="3" width="15" height="13" rx="2" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const PackageIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
);

const ImageIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);

const CalculatorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <line x1="8" y1="6" x2="16" y2="6" />
    <line x1="16" y1="10" x2="16" y2="10" />
    <line x1="12" y1="10" x2="12" y2="10" />
    <line x1="8" y1="10" x2="8" y2="10" />
    <line x1="16" y1="14" x2="16" y2="14" />
    <line x1="12" y1="14" x2="12" y2="14" />
    <line x1="8" y1="14" x2="8" y2="14" />
    <line x1="16" y1="18" x2="16" y2="18" />
    <line x1="12" y1="18" x2="12" y2="18" />
    <line x1="8" y1="18" x2="8" y2="18" />
  </svg>
);

const AddIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

// ===================== COMPONENTS =====================
const StatusBadge = ({ status, isDark }) => {
  const t = getT(isDark);
  const isActive = status === "1";
  const config = isActive 
    ? { bg: "rgba(34,197,94,0.15)", color: t.success, label: "Active" }
    : { bg: "rgba(239,68,68,0.15)", color: t.danger, label: "Inactive" };
  return (
    <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>
      {config.label}
    </span>
  );
};

const Toast = ({ message, type, onClose, isDark }) => {
  const t = getT(isDark);
  return (
    <div style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: 1000, background: t.surface, border: `1px solid ${type === "error" ? t.danger : t.success}`, borderRadius: "12px", padding: "12px 20px", display: "flex", alignItems: "center", gap: "12px", boxShadow: t.shadow }}>
      <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: type === "error" ? t.danger : t.success }} />
      <span style={{ fontSize: "13px", color: type === "error" ? t.danger : t.success }}>{message}</span>
      <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted }}><CloseIcon /></button>
    </div>
  );
};

// ===================== MAIN COMPONENT - DELIVERY_FARE =====================
const DeliveryFare = ({ isDark = true }) => {
  const t = getT(isDark);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingFare, setEditingFare] = useState(null);
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [activeSection, setActiveSection] = useState("dynamic");
  
  // Data state
  const [deliveryFares, setDeliveryFares] = useState([]);

  // Form state for Dynamic Fare
  const [dynamicFormData, setDynamicFormData] = useState({
    name: "Delivery Fare",
    pic: null,
    map_icon: null,
    first_trip_km: "1",
    first_trip_fare: "0",
    second_trip_fare: "10",
    second_trip_km: "2",
    third_trip_km: "4",
    third_trip_fare: "10",
    constant_trip_km: "6",
    constant_trip_fare: "8",
    on_booking_fare: "2",
    status: "1",
    hide: "0",
    driver_first_trip_fare: "8",
    driver_second_trip_fare: "8",
    driver_third_trip_fare: "8",
    driver_constant_trip_fare: "8",
    driver_on_booking_fare: "0"
  });

  // Form state for Fixed Fare (Orders)
  const [fixedFormData, setFixedFormData] = useState({
    name: "",
    pic: null,
    map_icon: null,
    status: "1",
    hide: "0",
    fixed_orders: "0",
    fixed_Rupees: "0",
    per_kmfare: "0",
    customer_rate_per_km: "",
    driver_rate_per_km: ""
  });

  // Form state for KM Based Fare
  const [kmRanges, setKmRanges] = useState([
    { from_km: "", to_km: "", rupees: "" }
  ]);
  const [kmFareFormData, setKmFareFormData] = useState({
    name: "KM Based Fare",
    pic: null,
    map_icon: null,
    status: "1",
    hide: "0",
    KM_chat: "",
    customer_rate_per_km: "",
    driver_rate_per_km: ""
  });

  // Image previews
  const [picPreview, setPicPreview] = useState(null);
  const [mapIconPreview, setMapIconPreview] = useState(null);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    fetchAllFares();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  const fetchAllFares = async () => {
    setLoading(true);
    try {
      const result = await getData("deliveryfare/fetch_all_fare");
      if (result.status) {
        setDeliveryFares(result.data);
      } else {
        showToast(result.message || "Failed to fetch fares", "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showToast("Network error while fetching fares", "error");
    } finally {
      setLoading(false);
    }
  };

  // Parse KM_chat string to array
  const parseKmChat = (kmChat) => {
    if (!kmChat) return [{ from_km: "", to_km: "", rupees: "" }];
    try {
      const parsed = JSON.parse(kmChat);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
      return [{ from_km: "", to_km: "", rupees: "" }];
    } catch (e) {
      return [{ from_km: "", to_km: "", rupees: "" }];
    }
  };

  const handleOpenModal = (fare = null) => {
    if (fare) {
      setEditingFare(fare);
      const isFixedOrdersFare = fare.fixed_orders > 0 && (!fare.KM_chat || fare.KM_chat === "");
      const isKmBasedFare = fare.KM_chat && fare.KM_chat !== "";
      const isDynamicFare = fare.first_trip_km && fare.first_trip_km !== "0";
      
      if (isKmBasedFare) {
        setActiveSection("kmbased");
        setKmRanges(parseKmChat(fare.KM_chat));
        setKmFareFormData({
          id: fare.id,
          name: fare.name || "KM Based Fare",
          pic: null,
          map_icon: null,
          status: fare.status || "1",
          hide: fare.hide || "0",
          KM_chat: fare.KM_chat || "",
          customer_rate_per_km: fare.customer_rate_per_km || "",
          driver_rate_per_km: fare.driver_rate_per_km || ""
        });
      } else if (isFixedOrdersFare) {
        setActiveSection("fixed");
        setFixedFormData({
          id: fare.id,
          name: fare.name || "Fixed Delivery Fare",
          pic: null,
          map_icon: null,
          status: fare.status || "1",
          hide: fare.hide || "0",
          fixed_orders: fare.fixed_orders || "0",
          fixed_Rupees: fare.fixed_Rupees || "0",
          per_kmfare: fare.per_kmfare || "0",
          customer_rate_per_km: fare.customer_rate_per_km || "",
          driver_rate_per_km: fare.driver_rate_per_km || ""
        });
      } else if (isDynamicFare) {
        setActiveSection("dynamic");
        setDynamicFormData({
          id: fare.id,
          name: fare.name || "Delivery Fare",
          pic: null,
          map_icon: null,
          first_trip_km: fare.first_trip_km || "1",
          first_trip_fare: fare.first_trip_fare || "0",
          second_trip_fare: fare.second_trip_fare || "10",
          second_trip_km: fare.second_trip_km || "2",
          third_trip_km: fare.third_trip_km || "4",
          third_trip_fare: fare.third_trip_fare || "10",
          constant_trip_km: fare.constant_trip_km || "6",
          constant_trip_fare: fare.constant_trip_fare || "8",
          on_booking_fare: fare.on_booking_fare || "2",
          status: fare.status || "1",
          hide: fare.hide || "0",
          driver_first_trip_fare: fare.driver_first_trip_fare || "8",
          driver_second_trip_fare: fare.driver_second_trip_fare || "8",
          driver_third_trip_fare: fare.driver_third_trip_fare || "8",
          driver_constant_trip_fare: fare.driver_constant_trip_fare || "8",
          driver_on_booking_fare: fare.driver_on_booking_fare || "0"
        });
      }
      setPicPreview(fare.pic ? `${serverURL}/uploads/${fare.pic}` : null);
      setMapIconPreview(fare.map_icon ? `${serverURL}/uploads/${fare.map_icon}` : null);
    } else {
      setEditingFare(null);
      setActiveSection("dynamic");
      setDynamicFormData({
        name: "Delivery Fare",
        pic: null,
        map_icon: null,
        first_trip_km: "1",
        first_trip_fare: "0",
        second_trip_fare: "10",
        second_trip_km: "2",
        third_trip_km: "4",
        third_trip_fare: "10",
        constant_trip_km: "6",
        constant_trip_fare: "8",
        on_booking_fare: "2",
        status: "1",
        hide: "0",
        driver_first_trip_fare: "8",
        driver_second_trip_fare: "8",
        driver_third_trip_fare: "8",
        driver_constant_trip_fare: "8",
        driver_on_booking_fare: "0"
      });
      setFixedFormData({
        name: "Fixed Delivery Fare",
        pic: null,
        map_icon: null,
        status: "1",
        hide: "0",
        fixed_orders: "0",
        fixed_Rupees: "0",
        per_kmfare: "0",
        customer_rate_per_km: "",
        driver_rate_per_km: ""
      });
      setKmRanges([{ from_km: "", to_km: "", rupees: "" }]);
      setKmFareFormData({
        name: "KM Based Fare",
        pic: null,
        map_icon: null,
        status: "1",
        hide: "0",
        KM_chat: "",
        customer_rate_per_km: "",
        driver_rate_per_km: ""
      });
      setPicPreview(null);
      setMapIconPreview(null);
    }
    setShowModal(true);
  };

  const handleAddKmRange = () => {
    setKmRanges([...kmRanges, { from_km: "", to_km: "", rupees: "" }]);
  };

  const handleRemoveKmRange = (index) => {
    const newRanges = kmRanges.filter((_, i) => i !== index);
    setKmRanges(newRanges.length > 0 ? newRanges : [{ from_km: "", to_km: "", rupees: "" }]);
  };

  const handleKmRangeChange = (index, field, value) => {
    const newRanges = [...kmRanges];
    newRanges[index][field] = value;
    setKmRanges(newRanges);
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      if (type === "pic") {
        setPicPreview(previewUrl);
        if (activeSection === "dynamic") {
          setDynamicFormData({ ...dynamicFormData, pic: file });
        } else if (activeSection === "fixed") {
          setFixedFormData({ ...fixedFormData, pic: file });
        } else if (activeSection === "kmbased") {
          setKmFareFormData({ ...kmFareFormData, pic: file });
        }
      }
      if (type === "map_icon") {
        setMapIconPreview(previewUrl);
        if (activeSection === "dynamic") {
          setDynamicFormData({ ...dynamicFormData, map_icon: file });
        } else if (activeSection === "fixed") {
          setFixedFormData({ ...fixedFormData, map_icon: file });
        } else if (activeSection === "kmbased") {
          setKmFareFormData({ ...kmFareFormData, map_icon: file });
        }
      }
    }
  };

  const handleSaveFare = async () => {
    setSubmitting(true);
    
    try {
      let result;
      
      // Fixed Orders Section
      if (activeSection === "fixed") {
        if (!fixedFormData.name) {
          showToast("Name is required", "error");
          setSubmitting(false);
          return;
        }

        const submitFormData = new FormData();
        submitFormData.append("name", fixedFormData.name);
        submitFormData.append("status", fixedFormData.status);
        submitFormData.append("hide", fixedFormData.hide || "0");
        submitFormData.append("fixed_orders", fixedFormData.fixed_orders);
        submitFormData.append("fixed_Rupees", fixedFormData.fixed_Rupees);
        submitFormData.append("per_kmfare", fixedFormData.per_kmfare);
        submitFormData.append("customer_rate_per_km", fixedFormData.customer_rate_per_km);
        submitFormData.append("driver_rate_per_km", fixedFormData.driver_rate_per_km);
        
        if (fixedFormData.pic instanceof File) {
          submitFormData.append("pic", fixedFormData.pic);
        }
        if (fixedFormData.map_icon instanceof File) {
          submitFormData.append("map_icon", fixedFormData.map_icon);
        }
        
        if (editingFare) {
          submitFormData.append("id", editingFare.id);
          result = await postData("deliveryfare/update_fixedfare", submitFormData);
        } else {
          result = await postData("deliveryfare/add_fixedfare", submitFormData);
        }
        
        if (result.status) {
          showToast(editingFare ? "Fixed fare updated successfully" : "Fixed fare added successfully");
          fetchAllFares();
          setShowModal(false);
        } else {
          showToast(result.message || "Operation failed", "error");
        }
      } 
      // KM Based Fare Section
      else if (activeSection === "kmbased") {
        if (!kmFareFormData.name) {
          showToast("Name is required", "error");
          setSubmitting(false);
          return;
        }

        const validRanges = kmRanges.filter(range => range.from_km && range.to_km && range.rupees);
        if (validRanges.length === 0) {
          showToast("Please add at least one valid KM range", "error");
          setSubmitting(false);
          return;
        }

        const KM_chat = JSON.stringify(validRanges);
        
        const submitFormData = new FormData();
        submitFormData.append("name", kmFareFormData.name);
        submitFormData.append("status", kmFareFormData.status);
        submitFormData.append("hide", kmFareFormData.hide || "0");
        submitFormData.append("KM_chat", KM_chat);
        
        // ✅ FIX: Append customer and driver rates
        submitFormData.append("customer_rate_per_km", kmFareFormData.customer_rate_per_km || 0);
        submitFormData.append("driver_rate_per_km", kmFareFormData.driver_rate_per_km || 0);

        if (kmFareFormData.pic instanceof File) {
          submitFormData.append("pic", kmFareFormData.pic);
        }
        if (kmFareFormData.map_icon instanceof File) {
          submitFormData.append("map_icon", kmFareFormData.map_icon);
        }
        
        if (editingFare) {
          submitFormData.append("id", editingFare.id);
          result = await postData("deliveryfare/update_fixedkmfare", submitFormData);
        } else {
          result = await postData("deliveryfare/add_fixedkmfare", submitFormData);
        }
        
        if (result.status) {
          showToast(editingFare ? "KM based fare updated successfully" : "KM based fare added successfully");
          fetchAllFares();
          setShowModal(false);
        } else {
          showToast(result.message || "Operation failed", "error");
        }
      }
      // Dynamic Fare Section
      else {
        if (!dynamicFormData.name) {
          showToast("Name is required", "error");
          setSubmitting(false);
          return;
        }

        const submitFormData = new FormData();
        Object.keys(dynamicFormData).forEach(key => {
          if (key === "pic" || key === "map_icon") {
            if (dynamicFormData[key] instanceof File) {
              submitFormData.append(key, dynamicFormData[key]);
            }
          } else if (key !== "id" && dynamicFormData[key] !== null && dynamicFormData[key] !== undefined) {
            submitFormData.append(key, dynamicFormData[key]);
          }
        });
        
        if (editingFare) {
          submitFormData.append("id", editingFare.id);
          result = await postData("deliveryfare/update_fare", submitFormData);
        } else {
          result = await postData("deliveryfare/add_fare", submitFormData);
        }
        
        if (result.status) {
          showToast(editingFare ? "Dynamic fare updated successfully" : "Dynamic fare added successfully");
          fetchAllFares();
          setShowModal(false);
        } else {
          showToast(result.message || "Operation failed", "error");
        }
      }
    } catch (error) {
      console.error("Save error:", error);
      showToast("Network error while saving", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleToggleStatus = async (fare) => {
    const newStatus = fare.status === "1" ? "0" : "1";
    
    setSubmitting(true);
    try {
      const result = await postData("deliveryfare/update_status", { 
        id: fare.id, 
        status: newStatus 
      });
      if (result.status) {
        showToast(`Fare ${newStatus === "1" ? "activated" : "deactivated"} successfully`);
        fetchAllFares();
      } else {
        showToast(result.message || "Status update failed", "error");
      }
    } catch (error) {
      console.error("Status update error:", error);
      showToast("Network error while updating status", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const filteredFares = deliveryFares.filter(fare => 
    fare.name?.toLowerCase().includes(search.toLowerCase()) ||
    fare.status?.toString().includes(search)
  );

  const styles = {
    container: {
      minHeight: "100vh",
      background: t.bg,
      fontFamily: "'Inter', 'DM Sans', sans-serif",
      padding: isMobile ? "16px" : "24px",
    },
    contentWrapper: {
      maxWidth: "1600px",
      margin: "0 auto",
    },
    header: {
      marginBottom: "28px",
    },
    title: {
      fontSize: isMobile ? "24px" : "32px",
      fontWeight: 700,
      background: "linear-gradient(135deg, #6c63ff, #a855f7)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      margin: 0,
    },
    subtitle: {
      fontSize: "14px",
      color: t.textMuted,
      marginTop: "8px",
    },
    card: {
      background: t.surface,
      border: `1px solid ${t.border}`,
      borderRadius: "24px",
      overflow: "hidden",
      boxShadow: t.shadow,
    },
    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px 24px",
      borderBottom: `1px solid ${t.border}`,
      background: t.surfaceAlt,
      flexWrap: "wrap",
      gap: "12px",
    },
    cardTitle: {
      fontSize: "18px",
      fontWeight: 700,
      color: t.text,
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    searchWrapper: {
      position: "relative",
      width: isMobile ? "100%" : "280px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 36px",
      background: t.surface,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "13px",
      color: t.text,
      outline: "none",
    },
    addButton: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 20px",
      background: "linear-gradient(135deg, #6c63ff, #a855f7)",
      border: "none",
      borderRadius: "12px",
      color: "#fff",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
    },
    headerActions: {
      display: "flex",
      gap: "20px",
      alignItems: "center",
      flexWrap: "wrap",
    },
    tableWrapper: {
      overflowX: "auto",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "1300px",
    },
    th: {
      padding: "16px 12px",
      textAlign: "left",
      fontSize: "12px",
      fontWeight: 700,
      color: t.accent,
      borderBottom: `1px solid ${t.border}`,
      background: t.surfaceAlt,
    },
    td: {
      padding: "16px 12px",
      fontSize: "13px",
      color: t.textSub,
      borderBottom: `1px solid ${t.border}`,
    },
    actionButtons: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      flexWrap: "wrap",
    },
    editBtn: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      padding: "6px 12px",
      borderRadius: "8px",
      border: "none",
      fontSize: "11px",
      fontWeight: 500,
      cursor: "pointer",
      background: t.info,
      color: "#fff",
    },
    toggleBtn: (isActive) => ({
      padding: "6px 12px",
      borderRadius: "20px",
      border: "none",
      fontSize: "11px",
      fontWeight: 500,
      cursor: "pointer",
      background: isActive ? t.success : t.warning,
      color: "#fff",
    }),
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1000,
      background: "rgba(0,0,0,0.7)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    },
    modal: {
      background: t.surface,
      border: `1px solid ${t.border}`,
      borderRadius: "28px",
      width: isMobile ? "100%" : "950px",
      maxHeight: "85vh",
      display: "flex",
      flexDirection: "column",
      boxShadow: t.shadow,
    },
    modalHeader: {
      padding: "20px 24px",
      borderBottom: `1px solid ${t.border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexShrink: 0,
      background: t.surface,
      borderRadius: "28px 28px 0 0",
    },
    modalTitle: {
      fontSize: "20px",
      fontWeight: 700,
      color: t.text,
    },
    modalBody: {
      padding: "24px",
      overflowY: "auto",
      flex: 1,
    },
    modalFooter: {
      padding: "16px 24px",
      borderTop: `1px solid ${t.border}`,
      display: "flex",
      gap: "12px",
      justifyContent: "flex-end",
      flexShrink: 0,
      background: t.surface,
      borderRadius: "0 0 28px 28px",
    },
    formGroup: {
      marginBottom: "20px",
    },
    label: {
      display: "block",
      fontSize: "12px",
      fontWeight: 600,
      color: t.textMuted,
      marginBottom: "6px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    input: {
      width: "100%",
      padding: "12px 14px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "14px",
      color: t.text,
      outline: "none",
      fontFamily: "inherit",
    },
    select: {
      width: "100%",
      padding: "12px 14px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "14px",
      color: t.text,
      outline: "none",
      cursor: "pointer",
    },
    fileInput: {
      width: "100%",
      padding: "10px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      fontSize: "13px",
      color: t.text,
      cursor: "pointer",
    },
    imagePreview: {
      width: "80px",
      height: "80px",
      objectFit: "cover",
      borderRadius: "12px",
      marginTop: "12px",
      border: `2px solid ${t.border}`,
    },
    cancelBtn: {
      padding: "10px 24px",
      background: t.surfaceAlt,
      border: `1px solid ${t.border}`,
      borderRadius: "12px",
      color: t.text,
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 500,
    },
    saveBtn: {
      padding: "10px 24px",
      background: "linear-gradient(135deg, #6c63ff, #a855f7)",
      border: "none",
      borderRadius: "12px",
      color: "#fff",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "13px",
    },
    rowCount: {
      padding: "16px 24px",
      borderTop: `1px solid ${t.border}`,
      fontSize: "12px",
      color: t.textMuted,
      background: t.surfaceAlt,
    },
    loadingText: {
      textAlign: "center",
      padding: "60px",
      color: t.textMuted,
      fontSize: "14px",
    },
    sectionToggle: {
      display: "flex",
      gap: "12px",
      marginBottom: "24px",
      background: t.surfaceAlt,
      padding: "6px",
      borderRadius: "16px",
      flexWrap: "wrap",
    },
    toggleButton: (isActive) => ({
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 20px",
      background: isActive ? "linear-gradient(135deg, #6c63ff, #a855f7)" : "transparent",
      border: "none",
      borderRadius: "12px",
      fontSize: "13px",
      fontWeight: 600,
      color: isActive ? "#fff" : t.text,
      cursor: "pointer",
      transition: "all 0.2s",
      flex: 1,
      justifyContent: "center",
    }),
    dynamicSection: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    fixedSection: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    kmBasedSection: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    sectionCard: {
      background: t.surfaceAlt,
      borderRadius: "16px",
      padding: "20px",
    },
    sectionTitle: {
      fontSize: "14px",
      fontWeight: 600,
      color: t.accent,
      marginBottom: "16px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    grid3: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
      gap: "16px",
    },
    grid2: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "16px",
    },
    rangeRow: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr auto",
      gap: "12px",
      alignItems: "center",
      marginBottom: "12px",
    },
    addButtonSmall: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "8px 16px",
      background: "transparent",
      border: `2px dashed ${t.border}`,
      borderRadius: "12px",
      color: t.accent,
      fontSize: "12px",
      fontWeight: 500,
      cursor: "pointer",
      marginTop: "12px",
      width: "100%",
      justifyContent: "center",
    },
    deleteBtnSmall: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "8px",
      background: t.danger,
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      color: "#fff",
    },
  };

  // Render mobile card view
  const renderMobileCard = (fare, index) => {
    let kmRangesDisplay = "-";
    if (fare.KM_chat) {
      try {
        const ranges = JSON.parse(fare.KM_chat);
        if (ranges.length > 0) {
          kmRangesDisplay = ranges.map(r => `${r.from_km}-${r.to_km}km: ₹${r.rupees}`).join(", ");
        }
      } catch(e) {}
    }
    
    return (
      <div key={fare.id} style={{ 
        background: t.surfaceAlt, 
        borderRadius: "16px", 
        marginBottom: "12px",
        padding: "16px",
        border: `1px solid ${t.border}`
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
          <strong style={{ color: t.text }}>#{index + 1} - {fare.name}</strong>
          <StatusBadge status={fare.status} isDark={isDark} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "12px" }}>
          <div><span style={{ color: t.textMuted }}>ID:</span> {fare.id}</div>
          <div><span style={{ color: t.textMuted }}>Type:</span> {fare.first_trip_km ? "Dynamic" : fare.fixed_orders ? "Fixed Orders" : "KM Based"}</div>
          <div><span style={{ color: t.textMuted }}>Fixed Orders:</span> {fare.fixed_orders || "-"}</div>
          <div><span style={{ color: t.textMuted }}>Fixed Price:</span> {fare.fixed_Rupees ? `₹${fare.fixed_Rupees}` : "-"}</div>
          <div><span style={{ color: t.textMuted }}>Per KM Fare:</span> {fare.per_kmfare ? `₹${fare.per_kmfare}` : "-"}</div>
          <div style={{ gridColumn: "span 2" }}><span style={{ color: t.textMuted }}>KM Ranges:</span> {kmRangesDisplay}</div>
        </div>
        <div style={styles.actionButtons}>
          <button style={styles.editBtn} onClick={() => handleOpenModal(fare)}>
            <EditIcon /> Edit
          </button>
          <button 
            style={styles.toggleBtn(fare.status === "1")} 
            onClick={() => handleToggleStatus(fare)}
            disabled={submitting}
          >
            {fare.status === "1" ? "Deactivate" : "Activate"}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <div style={styles.header}>
          <h1 style={styles.title}>💰 Delivery Fare Management</h1>
          <p style={styles.subtitle}>Configure delivery charges, booking fees, and fare rules</p>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>
              <TruckIcon /> Delivery Fare Configuration
            </h3>
            <div style={styles.headerActions}>
              <div style={styles.searchWrapper}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }}><SearchIcon /></span>
                <input 
                  style={styles.searchInput} 
                  placeholder="Search by name or status..." 
                  value={search} 
                  onChange={(e) => setSearch(e.target.value)} 
                />
              </div>
              <button style={styles.addButton} onClick={() => handleOpenModal()}>
                <PlusIcon /> Add Fare
              </button>
            </div>
          </div>

          <div style={styles.tableWrapper}>
            {loading ? (
              <div style={styles.loadingText}>Loading fares...</div>
            ) : (
              isMobile ? (
                filteredFares.map((fare, index) => renderMobileCard(fare, index))
              ) : (
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>SN</th>
                      <th style={styles.th}>ID</th>
                      <th style={styles.th}>Name</th>
                      <th style={styles.th}>Cust. Rate/KM</th>
                      <th style={styles.th}>Driver Rate/KM</th>
                      <th style={styles.th}>1st KM/Fare</th>
                      <th style={styles.th}>2nd KM/Fare</th>
                      <th style={styles.th}>3rd KM/Fare</th>
                      <th style={styles.th}>Constant KM/Fare</th>
                      <th style={styles.th}>Booking Fee</th>
                      <th style={styles.th}>Fixed Orders</th>
                      <th style={styles.th}>Fixed Price</th>
                      <th style={styles.th}>Per KM Fare</th>
                      <th style={styles.th}>KM Ranges</th>
                      <th style={styles.th}>Driver Fares</th>
                      <th style={styles.th}>Status</th>
                      <th style={styles.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredFares.map((fare, index) => {
                      let kmRangesDisplay = "-";
                      if (fare.KM_chat) {
                        try {
                          const ranges = JSON.parse(fare.KM_chat);
                          if (ranges.length > 0) {
                            kmRangesDisplay = ranges.map(r => `${r.from_km}-${r.to_km}km:₹${r.rupees}`).join(", ");
                          }
                        } catch(e) {}
                      }
                      
                      return (
                        <tr key={fare.id}>
                          <td style={styles.td}>{index + 1}</td>
                          <td style={styles.td}>{fare.id}</td>
                          <td style={styles.td}><strong style={{ color: t.text }}>{fare.name}</strong></td>
                          <td style={styles.td}><span style={{color: t.success, fontWeight:'bold'}}>₹{fare.customer_rate_per_km || "0"}</span></td>
                          <td style={styles.td}><span style={{color: t.accent, fontWeight:'bold'}}>₹{fare.driver_rate_per_km || "0"}</span></td>
                          <td style={styles.td}>{fare.first_trip_km && fare.first_trip_km !== "0" ? `${fare.first_trip_km} km / $${fare.first_trip_fare}` : "-"}</td>
                          <td style={styles.td}>{fare.second_trip_km && fare.second_trip_km !== "0" ? `${fare.second_trip_km} km / $${fare.second_trip_fare}` : "-"}</td>
                          <td style={styles.td}>{fare.third_trip_km && fare.third_trip_km !== "0" ? `${fare.third_trip_km} km / $${fare.third_trip_fare}` : "-"}</td>
                          <td style={styles.td}>{fare.constant_trip_km && fare.constant_trip_km !== "0" ? `${fare.constant_trip_km} km / $${fare.constant_trip_fare}` : "-"}</td>
                          <td style={styles.td}>{fare.on_booking_fare && fare.on_booking_fare !== "0" ? `$${fare.on_booking_fare}` : "-"}</td>
                          <td style={styles.td}>{fare.fixed_orders && fare.fixed_orders !== "0" ? `${fare.fixed_orders} orders` : "-"}</td>
                          <td style={styles.td}>{fare.fixed_Rupees && fare.fixed_Rupees !== "0" ? `₹${fare.fixed_Rupees}` : "-"}</td>
                          <td style={styles.td}>{fare.per_kmfare && fare.per_kmfare !== "0" ? `₹${fare.per_kmfare}` : "-"}</td>
                          <td style={styles.td}>{kmRangesDisplay}</td>
                          <td style={styles.td}>
                            {fare.driver_first_trip_fare && fare.driver_first_trip_fare !== "0" ? (
                              <div style={{ fontSize: "10px" }}>
                                First: ${fare.driver_first_trip_fare}<br />
                                Second: ${fare.driver_second_trip_fare}<br />
                                Constant: ${fare.driver_constant_trip_fare}
                              </div>
                            ) : "-"}
                          </td>
                          <td style={styles.td}><StatusBadge status={fare.status} isDark={isDark} /></td>
                          <td style={styles.td}>
                            <div style={styles.actionButtons}>
                              <button style={styles.editBtn} onClick={() => handleOpenModal(fare)}>
                                <EditIcon /> Edit
                              </button>
                              <button 
                                style={styles.toggleBtn(fare.status === "1")} 
                                onClick={() => handleToggleStatus(fare)}
                                disabled={submitting}
                              >
                                {fare.status === "1" ? "Deactivate" : "Activate"}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )
            )}
          </div>

          <div style={styles.rowCount}>
            Rows: 20 ▼ | {filteredFares.length} of {deliveryFares.length} — Page 1/1
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>{editingFare ? "Edit Delivery Fare" : "Create New Fare"}</div>
              <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: t.textMuted, padding: "8px", borderRadius: "8px" }}>
                <CloseIcon />
              </button>
            </div>
            <div style={styles.modalBody}>
              {/* Section Toggle Buttons */}
              <div style={styles.sectionToggle}>
                <button 
                  style={styles.toggleButton(activeSection === "dynamic")}
                  onClick={() => setActiveSection("dynamic")}
                >
                  <TruckIcon /> Dynamic Fare (KM Based)
                </button>
                <button 
                  style={styles.toggleButton(activeSection === "fixed")}
                  onClick={() => setActiveSection("fixed")}
                >
                  <PackageIcon /> Fixed Orders
                </button>
                <button 
                  style={styles.toggleButton(activeSection === "kmbased")}
                  onClick={() => setActiveSection("kmbased")}
                >
                  <CalculatorIcon /> KM Based Fare
                </button>
              </div>

              {/* Dynamic Fare Section */}
              {activeSection === "dynamic" && (
                <div style={styles.dynamicSection}>
                  <div style={styles.grid2}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Fare Name *</label>
                      <input style={styles.input} value={dynamicFormData.name} onChange={(e) => setDynamicFormData({ ...dynamicFormData, name: e.target.value })} placeholder="e.g., Standard Delivery" />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Status</label>
                      <select style={styles.select} value={dynamicFormData.status} onChange={(e) => setDynamicFormData({ ...dynamicFormData, status: e.target.value })}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div style={styles.sectionCard}>
                    <div style={styles.sectionTitle}>
                      <CalculatorIcon /> Pricing per Kilometer
                    </div>
                    <div style={styles.grid2}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Customer Rate (₹ per KM) *</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={fixedFormData.customer_rate_per_km} 
                          onChange={(e) => setFixedFormData({ ...fixedFormData, customer_rate_per_km: e.target.value })}
                          placeholder="e.g. 15"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver Rate (₹ per KM) *</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={fixedFormData.driver_rate_per_km} 
                          onChange={(e) => setFixedFormData({ ...fixedFormData, driver_rate_per_km: e.target.value })}
                          placeholder="e.g. 10"
                        />
                      </div>
                    </div>
                    
                    <div style={{...styles.grid2, marginTop: '20px'}}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Fixed Price (₹)</label>
                        <input type="number" style={styles.input} value={fixedFormData.fixed_Rupees} onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_Rupees: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Fixed Orders (Qty)</label>
                        <input type="number" style={styles.input} value={fixedFormData.fixed_orders} onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_orders: e.target.value })} />
                      </div>
                    </div>
                  </div>
                  <div style={styles.sectionCard}>
                    <div style={styles.sectionTitle}>
                      <TruckIcon /> Customer Fares
                    </div>
                    <div style={styles.grid3}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>1st Trip KM</label>
                        <input type="number" style={styles.input} value={dynamicFormData.first_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, first_trip_km: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>1st Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.first_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, first_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>2nd Trip KM</label>
                        <input type="number" style={styles.input} value={dynamicFormData.second_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, second_trip_km: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>2nd Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.second_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, second_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>3rd Trip KM</label>
                        <input type="number" style={styles.input} value={dynamicFormData.third_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, third_trip_km: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>3rd Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.third_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, third_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Constant Trip KM</label>
                        <input type="number" style={styles.input} value={dynamicFormData.constant_trip_km} onChange={(e) => setDynamicFormData({ ...dynamicFormData, constant_trip_km: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Constant Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.constant_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, constant_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>On Booking Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.on_booking_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, on_booking_fare: e.target.value })} />
                      </div>
                    </div>
                  </div>

                  <div style={styles.grid2}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Customer Rate (₹ per KM) *</label>
                      <input 
                        type="number" 
                        style={styles.input} 
                        value={fixedFormData.customer_rate_per_km} 
                        onChange={(e) => setFixedFormData({ ...fixedFormData, customer_rate_per_km: e.target.value })}
                        placeholder="Apna rate bhariyo (e.g. 12)"
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Driver Rate (₹ per KM) *</label>
                      <input 
                        type="number" 
                        style={styles.input} 
                        value={fixedFormData.driver_rate_per_km} 
                        onChange={(e) => setFixedFormData({ ...fixedFormData, driver_rate_per_km: e.target.value })}
                        placeholder="Driver ka rate (e.g. 9)"
                      />
                    </div>
                  </div>

                  <div style={styles.sectionCard}>
                    <div style={styles.sectionTitle}>
                      👨‍✈️ Driver Fares
                    </div>
                    <div style={styles.grid3}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver 1st Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.driver_first_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_first_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver 2nd Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.driver_second_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_second_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver 3rd Trip Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.driver_third_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_third_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver Constant Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.driver_constant_trip_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_constant_trip_fare: e.target.value })} />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver On Booking Fare ($)</label>
                        <input type="number" style={styles.input} value={dynamicFormData.driver_on_booking_fare} onChange={(e) => setDynamicFormData({ ...dynamicFormData, driver_on_booking_fare: e.target.value })} />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Fixed Orders Section */}
              {activeSection === "fixed" && (
                <div style={styles.fixedSection}>
                  <div style={styles.grid2}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Fare Name *</label>
                      <input style={styles.input} value={fixedFormData.name} onChange={(e) => setFixedFormData({ ...fixedFormData, name: e.target.value })} placeholder="e.g., Bulk Order Pricing" />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Status</label>
                      <select style={styles.select} value={fixedFormData.status} onChange={(e) => setFixedFormData({ ...fixedFormData, status: e.target.value })}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div style={styles.sectionCard}>
                    <div style={styles.sectionTitle}>
                      <PackageIcon /> Fixed Orders Configuration
                    </div>
                    <div style={styles.grid2}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Fixed Orders (Quantity)</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={fixedFormData.fixed_orders} 
                          onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_orders: e.target.value })}
                          placeholder="Number of orders"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Fixed Price (₹)</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={fixedFormData.fixed_Rupees} 
                          onChange={(e) => setFixedFormData({ ...fixedFormData, fixed_Rupees: e.target.value })}
                          placeholder="Total price in Rupees"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Per KM Fare (₹)</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={fixedFormData.per_kmfare} 
                          onChange={(e) => setFixedFormData({ ...fixedFormData, per_kmfare: e.target.value })}
                          placeholder="Price per kilometer"
                        />
                        <small style={{ color: t.textMuted, fontSize: "10px", marginTop: "6px", display: "block" }}>
                          Additional charge per kilometer
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* KM Based Fare Section */}
              {activeSection === "kmbased" && (
                <div style={styles.kmBasedSection}>
                  <div style={styles.sectionCard}>
                    <div style={styles.sectionTitle}><CalculatorIcon /> Global Rates (Standard)</div>
                    <div style={styles.grid2}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Customer Rate (₹ per KM) *</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={kmFareFormData.customer_rate_per_km} 
                          onChange={(e) => setKmFareFormData({ ...kmFareFormData, customer_rate_per_km: e.target.value })}
                          placeholder="e.g. 15"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Driver Rate (₹ per KM) *</label>
                        <input 
                          type="number" 
                          style={styles.input} 
                          value={kmFareFormData.driver_rate_per_km} 
                          onChange={(e) => setKmFareFormData({ ...kmFareFormData, driver_rate_per_km: e.target.value })}
                          placeholder="e.g. 10"
                        />
                      </div>
                    </div>
                  </div>

                  <div style={styles.grid2}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Fare Name *</label>
                      <input style={styles.input} value={kmFareFormData.name} onChange={(e) => setKmFareFormData({ ...kmFareFormData, name: e.target.value })} placeholder="e.g., Distance Based Pricing" />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Status</label>
                      <select style={styles.select} value={kmFareFormData.status} onChange={(e) => setKmFareFormData({ ...kmFareFormData, status: e.target.value })}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div style={styles.sectionCard}>
                    <div style={styles.sectionTitle}>
                      <CalculatorIcon /> KM Ranges Configuration
                    </div>
                    
                    {kmRanges.map((range, idx) => (
                      <div key={idx} style={styles.rangeRow}>
                        <div style={styles.formGroup}>
                          <label style={styles.label}>From KM</label>
                          <input 
                            type="number" 
                            style={styles.input} 
                            value={range.from_km} 
                            onChange={(e) => handleKmRangeChange(idx, "from_km", e.target.value)}
                            placeholder="From"
                          />
                        </div>
                        <div style={styles.formGroup}>
                          <label style={styles.label}>To KM</label>
                          <input 
                            type="number" 
                            style={styles.input} 
                            value={range.to_km} 
                            onChange={(e) => handleKmRangeChange(idx, "to_km", e.target.value)}
                            placeholder="To"
                          />
                        </div>
                        <div style={styles.formGroup}>
                          <label style={styles.label}>Rupees (₹)</label>
                          <input 
                            type="number" 
                            style={styles.input} 
                            value={range.rupees} 
                            onChange={(e) => handleKmRangeChange(idx, "rupees", e.target.value)}
                            placeholder="Price"
                          />
                        </div>
                        <div>
                          <label style={{ visibility: "hidden" }}>Action</label>
                          <button 
                            style={styles.deleteBtnSmall} 
                            onClick={() => handleRemoveKmRange(idx)}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      </div>
                    ))}
                    
                    <button style={styles.addButtonSmall} onClick={handleAddKmRange}>
                      <AddIcon /> Add KM Range
                    </button>
                  </div>
                </div>
              )}

              {/* Images Section */}
              <div style={styles.sectionCard}>
                <div style={styles.sectionTitle}>
                  <ImageIcon /> Brand Images
                </div>
                <div style={styles.grid2}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Picture / Logo</label>
                    <input type="file" style={styles.fileInput} accept="image/*" onChange={(e) => handleFileChange(e, "pic")} />
                    {picPreview && <img src={picPreview} alt="Preview" style={styles.imagePreview} />}
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Map Icon</label>
                    <input type="file" style={styles.fileInput} accept="image/*" onChange={(e) => handleFileChange(e, "map_icon")} />
                    {mapIconPreview && <img src={mapIconPreview} alt="Map Icon Preview" style={styles.imagePreview} />}
                  </div>
                </div>
              </div>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSaveFare} disabled={submitting}>
                {submitting ? "Saving..." : (editingFare ? "Update Fare" : "Create Fare")}
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} isDark={isDark} />}
    </div>
  );
};

export default DeliveryFare;